import { useState, useEffect } from 'react';
import '../../entrydoor.css';

// Pleated screen profiles. Restrictions are applied by the configurator:
//   singleLeafOnly  -> only the Single Leaf screen type is allowed
//   screenSizeOnly  -> measurement type is fixed to 'Screen Size' (no sub frame)
export const SCREEN_PROFILES = [
    { id: 1, value: 'Z-28', label: 'Z-28' },
    { id: 2, value: 'Z-19-45', label: 'Z-19-45', singleLeafOnly: true, screenSizeOnly: true },
];

export const getScreenProfile = (value) =>
    SCREEN_PROFILES.find(p => p.value === value) || SCREEN_PROFILES[0];

const ScreenProfile = ({ value, onChange, id = 'ScreenProfile', label = 'Profile', disabled = false }) => {
    const [selectedProfile, setSelectedProfile] = useState(value || '');

    useEffect(() => {
        setSelectedProfile(value || '');
    }, [value]);

    // Trigger initial onChange once when component mounts
    useEffect(() => {
        if (!selectedProfile) {
            const defaultOption = SCREEN_PROFILES[0];
            setSelectedProfile(defaultOption.value);
            onChange(defaultOption.value);
        }
    }, []);

    const handleProfileChange = (e) => {
        const option = getScreenProfile(e.target.value);
        setSelectedProfile(option.value);
        onChange(option.value);
    };

    return (
        <div className="a-container">
            <label htmlFor={id} disabled={disabled}>
                {label}
            </label>
            <select
                disabled={disabled}
                id={id}
                value={selectedProfile}
                onChange={handleProfileChange}
            >
                {SCREEN_PROFILES.map(option => (
                    <option key={option.id} value={option.value}>
                        {selectedProfile === option.value ? `${option.label} ✔` : option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default ScreenProfile;
